import { render, staticRenderFns } from "./CampaignProblems.vue?vue&type=template&id=c29b4762"
import script from "./CampaignProblems.vue?vue&type=script&lang=js"
export * from "./CampaignProblems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports